// extracted by mini-css-extract-plugin
module.exports = {"givePriority":"styles_givePriority__3bS4P","comparisonSelect":"styles_comparisonSelect__2jD-A","select":"styles_select__snqnU"};